import { translateLanguage } from 'components';
import { intialPatientData } from 'constants/patients';
import { DATE_FORMAT_MDY, NEW_PATIENT, PHONE_TYPE } from 'constants/utilities';
import { AddEditAppoinmentContent, ErrResponce } from 'models';
import moment from 'moment';
import { useQueryClient } from 'react-query';
import { initialState } from 'views/addEditAppointment/commonFiles';
import { convertLocaleDateToUTCDate } from './formatDate';
import { addHoursToTime, convertTime12to24 } from './formatTime';

let appointmentStartDate = '';
let appointmentEndDate = '';

export const bookingPrepare = (getValues: any, appointmentData: any, stripePaymentResponse?: any, paymentMethodId?: any) => {
  const {
    firstName,
    lastName,
    dob,
    // gender,
    phoneNumber,
    email,
    staffId,
    locationId,
    procedureId,
  } = getValues();

  const formattedAppointmentDate = moment(appointmentData.bookingDate).format(
    DATE_FORMAT_MDY,
  );

  appointmentStartDate = `${formattedAppointmentDate} ${convertTime12to24(
    appointmentData.timeSlot,
  )}`;

  appointmentEndDate = `${formattedAppointmentDate} ${addHoursToTime(
    appointmentStartDate,
    appointmentData.procedureDuration,
  )}`;

  const bookingPayload = {
    patientDto: {
      ...intialPatientData,
      id: 0,
      referrerPatientID: 0,
      fullName: `${firstName} ${lastName}`,
      firstName,
      lastName,
      primaryPhoneType1: PHONE_TYPE,
      primaryPhone1: phoneNumber,
      primaryEmailAddress: email,
      dateofBirth: convertLocaleDateToUTCDate(dob),
      physicianId: staffId,
      // sex: gender,
      locationId,
    },
    appointment: {
      ...initialState,
      firstName,
      lastName,
      dateOfBirth: convertLocaleDateToUTCDate(dob),
      eventLength: null,
      procedureId: procedureId.toString(),
      start_date: appointmentStartDate,
      end_date: appointmentEndDate,
      patientName: `${firstName} ${lastName}`,
      procedureNames: appointmentData.procedureName,
      procDetails: appointmentData.procedureName,
      patientFullName: `${firstName} ${lastName}`,
      staffIds: [staffId],
      procedureIds: [procedureId],
      areaIds: [],
      LocationId: locationId,
      patientType: NEW_PATIENT,
      patientID: 0,
      selectedDevice:appointmentData?.selectedDevice || []
    },
    stripePaymentResponse,
    paymentMethodId,
  };

  return bookingPayload;
};

// conflicting error messages
const patientconflictResponse = () => {
  const queryClient = useQueryClient();
  const getDate = new Date(appointmentStartDate);
  const date = moment(getDate).format('ddd, MMM DD,yyyy');
  const getStartTime = new Date(appointmentStartDate);
  const startTime = moment(getStartTime).format('hh:mm A');
  const getEndTime = new Date(appointmentEndDate);
  const endTime = moment(getEndTime).format('hh:mm A');
  const patientConflictMessage = `${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.PatientconflictResponce]}`,
  )} ${date} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.Between]}`,
  )} ${startTime} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.And]}`,
  )} ${endTime}.`;

  queryClient.setQueryData(['toast-message'], {
    message: patientConflictMessage,
    type: 'error',
  });
};

const staffconflictResponse = () => {
  const queryClient = useQueryClient();
  const getDate = new Date(appointmentStartDate);
  const date = moment(getDate).format('ddd, MMM DD,yyyy');
  const getStartTime = new Date(appointmentStartDate);
  const startTime = moment(getStartTime).format('hh:mm A');
  const getEndTime = new Date(appointmentEndDate);
  const endTime = moment(getEndTime).format('hh:mm A');
  const StaffConflictMessage = `${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.StaffconflictResponce]}`,
  )} ${date} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.Between]}`,
  )} ${startTime} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.And]}`,
  )} ${endTime}.`;

  queryClient.setQueryData(['toast-message'], {
    message: StaffConflictMessage,
    type: 'error',
  });
};

const existingWaitlistedAppointmentResponse = () => {
  const queryClient = useQueryClient();
  const getDate = new Date(appointmentStartDate);
  const date = moment(getDate).format('ddd, MMM DD,yyyy');
  const getStartTime = new Date(appointmentStartDate);
  const startTime = moment(getStartTime).format('hh:mm A');
  const getEndTime = new Date(appointmentEndDate);
  const endTime = moment(getEndTime).format('hh:mm A');
  const ExistingWaitlistedAppointmentConflictMessage = `${translateLanguage(
    `AddEditAppointment.${[
      AddEditAppoinmentContent.ExistingWaitlistedAppointmentMsg,
    ]}`,
  )} ${date} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.Between]}`,
  )} ${startTime} ${translateLanguage(
    `AddEditAppointment.${[AddEditAppoinmentContent.And]}`,
  )} ${endTime}.`;

  queryClient.setQueryData(['toast-message'], {
    message: ExistingWaitlistedAppointmentConflictMessage,
    type: 'error',
  });
};

export const responseMessages = (errorMsg: any) => {
  const queryClient = useQueryClient();
  switch (errorMsg) {
    case `${[ErrResponce.GoToAccessError]}`:
      queryClient.setQueryData(['toast-message'], {
        message: translateLanguage(
          `AddEditAppointment.${[AddEditAppoinmentContent.AddGoToAccessError]}`,
        ),
        type: 'error',
      });
      break;
    case `${[ErrResponce.GoToMeetError]}`:
      queryClient.setQueryData(['toast-message'], {
        message: translateLanguage(
          `AddEditAppointment.${[AddEditAppoinmentContent.AddGoToMeetError]}`,
        ),
        type: 'error',
      });
      break;
    case `${[ErrResponce.GoToMeetingNotEnabled]}`:
      queryClient.setQueryData(['toast-message'], {
        message: translateLanguage(
          `AddEditAppointment.${[
            AddEditAppoinmentContent.GoToMeetingNotEnabledErr,
          ]}`,
        ),
        type: 'error',
      });
      break;

    case `${[ErrResponce.ExistingWaitlistedAppointment]}`:
      existingWaitlistedAppointmentResponse();
      break;
    default:
      return queryClient.setQueryData(['toast-message'], {
        message: errorMsg,
        type: 'error',
      });
  }
};

export const conflictResponse = (errorMsg: any) => {
  switch (errorMsg) {
    case `${AddEditAppoinmentContent.ExistingAppointmentPatient}`:
      patientconflictResponse();
      break;
    case `${AddEditAppoinmentContent.ExistingAppointmentStaff}`:
      staffconflictResponse();
      break;
    default:
      return '';
  }
};
